import { render, staticRenderFns } from "./PortalTime.vue?vue&type=template&id=3ed22095&scoped=true&"
import script from "./PortalTime.vue?vue&type=script&lang=ts&"
export * from "./PortalTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed22095",
  null
  
)

export default component.exports